import * as actionTypes from 'Front/actions/actionTypes'
const initState = {
    response: [],
    message: '',
    isBillCategoryList: false,
    isBillCategoryListError: false,
    billCategoryList: [],
    isBillSubCategoryList: false,
    isBillSubCategoryListError: false,
    billSubCategoryList: [],
    isBillCreated: false,
    isBillCreatedError: false,
    billCreated: null,
    isBillUpdated: false,
    isBillUpdatedError: false,
    billUpdated: null,
    isBillList: false,
    isBillListError: false,
    billList: [],
}

export default (state = initState, action = {}) => {
    switch (action.type) {
        // Patient List
        case actionTypes.GET_BILL_CATEGORY_LIST_REQUEST:
            return {
                ...state,
                message: '',
                isBillCategoryList: false,
                isBillCategoryListError: false,
            }
        case actionTypes.GET_BILL_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                message: 'Bill Category List successfully',
                billCategoryList: action.payload.response,
                isBillCategoryList: true,
                isBillCategoryListError: false,
            }
        case actionTypes.GET_BILL_CATEGORY_LIST_ERROR:
            return {
                ...state,
                response: action.payload.error,
                message: action.payload.error,
                isBillCategoryList: false,
                isBillCategoryListError: true
            }

        case actionTypes.GET_BILL_SUB_CATEGORY_LIST_REQUEST:
            return {
                ...state,
                message: '',
                isBillSubCategoryList: false,
                isBillSubCategoryListError: false,
            }
        case actionTypes.GET_BILL_SUB_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                message: 'Bill Sub Category List successfully',
                billSubCategoryList: action.payload.response,
                isBillSubCategoryList: true,
                isBillSubCategoryListError: false,
            }
        case actionTypes.GET_BILL_SUB_CATEGORY_LIST_ERROR:
            return {
                ...state,
                response: action.payload.error,
                message: action.payload.error,
                isBillSubCategoryList: false,
                isBillSubCategoryListError: true
            }
        case actionTypes.BILL_CREATE_REQUEST:
            return {
                ...state,
                message: '',
                isBillCreated: false,
                isBillCreatedError: false,
            }
        case actionTypes.BILL_CREATE_SUCCESS:
            return {
                ...state,
                message: 'Bill Created successfully',
                billCreated: action.payload.response,
                isBillCreated: true,
                isBillCreatedError: false,
            }
        case actionTypes.BILL_CREATE_ERROR:
            return {
                ...state,
                response: action.payload.error,
                message: action.payload.error,
                isBillCreated: false,
                isBillCreatedError: true
            }

        case actionTypes.BILL_UPDATE_REQUEST:
            return {
                ...state,
                message: '',
                isBillUpdated: false,
                isBillUpdatedError: false,
            }
        case actionTypes.BILL_UPDATE_SUCCESS:
            return {
                ...state,
                message: 'Bill Created successfully',
                billUpdated: action.payload.response,
                isBillUpdated: true,
                isBillUpdatedError: false,
            }
        case actionTypes.BILL_UPDATE_ERROR:
            return {
                ...state,
                response: action.payload.error,
                message: action.payload.error,
                isBillUpdated: false,
                isBillUpdatedError: true
            }

        case actionTypes.BILL_LIST_REQUEST:
            return {
                ...state,
                message: '',
                isBillList: false,
                isBillListError: false,
            }
        case actionTypes.BILL_LIST_SUCCESS:
            return {
                ...state,
                message: 'Bill Created successfully',
                billList: action.payload.response,
                isBillList: true,
                isBillListError: false,
            }
        case actionTypes.BILL_LIST_ERROR:
            return {
                ...state,
                response: action.payload.error,
                message: action.payload.error,
                isBillList: false,
                isBillListError: true
            }

        case actionTypes.SET_ALL_BILL_CATEGORY_LIST:
            return {
                ...state,
                billCategoryList: action?.payload || []
            }

        case actionTypes.SET_ALL_BILL_SUB_CATEGORY_LIST:
            return {
                ...state,
                billSubCategoryList: action?.payload || []
            }


        default:
            return state
    }
}